module.exports = __webpack_public_path__ + "static/media/Puerquitos de piloncillo.e2e94f7f.png";